import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { cssVariables } from "@oshimap/design-tokens";
import { App } from "./app/App";
import "./styles/base.css";

/** 토큰을 런타임에 주입한다 — 토큰 소스와 CSS 가 어긋날 수 없다 (NFR-MT-05). */
const style = document.createElement("style");
style.setAttribute("data-oshimap-tokens", "");
style.textContent = cssVariables();
document.head.prepend(style);

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
